import { Element, load } from 'cheerio';

export const parseHeaderTags = (html: string | undefined): ParsedNode[] => {
  if (!html) return [];
  const $ = load(html);
  return $('script,link,meta,style')
    .toArray()
    .map((el: Element) => {
      return {
        content: $(el).html(),
        tagName: el.tagName,
        props: attributesToProps(el.attributes),
      };
    });
};

export const attributesToProps = (attributes: Attribute[]): Record<string, unknown> => {
  return attributes.reduce((acc, current) => {
    if (!current.value) return acc;
    return { ...acc, [current.name]: current.value };
  }, {});
};

export interface ParsedNode {
  props: Record<string, unknown>;
  tagName: string;
  content: string | null;
}

export interface Attribute {
  name: string;
  value: string;
  namespace?: string;
  prefix?: string;
}
